import { RenewPasswordDialogComponent } from './../renew-password-dialog/renew-password-dialog.component';
import { Environment } from '@enauka/shared/application';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService, Credentials } from '@enauka/shared/infrastructure/auth/data-access';
import { Rola } from '@enauka/shared/common-dto';
import { DOCUMENT } from '@angular/common';
import { DialogService } from '@enauka/shared/ui/dialogs';

@Component({
  selector: 'enauka-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  credentials: Credentials = { username: '', password: '' };
  authenticated: boolean;
  logowanieUsos = false;
  error: string;
  czyPokazacUsos: boolean;
  sessionExpired: boolean;
  returnUrl: string;
  casUnavaliable: boolean;
  constructor(private authService: AuthService, private router: Router, private environment: Environment,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document) {
    this.logowanieUsos = this.environment.logowanieUsos;
  }

  ngOnInit(): void {
    this.sessionExpired = this.route.snapshot.queryParamMap.get('sessionExpired') === 'true';
    this.casUnavaliable = this.route.snapshot.queryParamMap.get('error') === 'cas-unavailable';
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.authService.isAuthenticated$().subscribe((authenticated) => {
      this.authenticated = authenticated;
      if (this.authenticated) {
        this.redirectAfterAuthentication();
      }
    })
  }


  login() {
    this.authService.authenticate(this.credentials).subscribe(resp => {
      this.redirectAfterAuthentication();
    }, (error) => {
      if (error.status === 401) {
        this.error = "Niepoprawne hasło lub nazwa użytkownika";
      } else if (error.status === 503) {
        this.error = "Usługa jest chwilowo niedostępna. Proszę spróbować ponownie za chwilę.";
      } else {
        this.error = "Wystąpił błąd podczas logowania";
      }
      console.error(error);
    });
  }

  private redirectAfterAuthentication() {
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
      return;
    }
    const user = this.authService.getUserPrincipal();
    switch (user.rola) {
      case Rola.ROLE_ADMIN:
      case Rola.ROLE_WDROZENIOWIEC:
      case Rola.ROLE_HELP_DESK:
        this.document.location.href = this.environment.helpdeskUrl;
        return;
      case Rola.ROLE_NAUCZYCIEL:
        this.document.location.href = this.environment.nauczycielUrl;
        return;
      case Rola.ROLE_UCZEN:
      case Rola.ROLE_STUDENT:
        this.document.location.href = this.environment.uczenUrl;
        return;
      default:
        return this.router.navigate(['/']);
    }
  }

  logout() {
    this.authService.logout().subscribe(resp => {
      this.document.location.replace('/')
    });
  }

  toggleCzyPokazacUsos() {
    this.czyPokazacUsos = !this.czyPokazacUsos;
  }

  pokazUsos() {
    return this.logowanieUsos && this.czyPokazacUsos;
  }

  renewPasswordButton() {
    RenewPasswordDialogComponent.open(this.dialogService);
    return false;
  }
}
